import React, { useState, useEffect } from 'react';
import ContactDetail from './ContactDetail';
import { authFetch } from '../auth/AuthContext';

const ROLES = ['All','Appraiser','Attorney','Borrower','Broker','Buyers Agent','CPA','Capital Partner','Contractor','Escrow Officer','GAP Funder','HOA','Insurance Agent','JV Partner','Listing Agent','Loan Officer','Notary','Other','PM Lender','Park Manager','Park Owner','Processor','Property Manager','Referral Partner','Seller','Title Officer','Wholesaler'];

const s = {
  toolbar:  { display:'flex', alignItems:'center', gap:'10px', marginBottom:'16px', flexWrap:'wrap' },
  search:   { flex:1, minWidth:'220px', padding:'9px 12px', border:'1px solid #C9D9EE', borderRadius:'8px', fontSize:'13px', outline:'none', fontFamily:'inherit', background:'#fff', color:'#33415A' },
  select:   { padding:'9px 12px', border:'1px solid #C9D9EE', borderRadius:'8px', fontSize:'13px', outline:'none', fontFamily:'inherit', cursor:'pointer', background:'#fff', color:'#33415A' },
  tableCard:{ background:'#fff', borderRadius:'12px', border:'1px solid #C9D9EE', overflow:'hidden', width:'100%', boxShadow:'0 1px 3px rgba(20,60,120,0.06)' },
  secBar:   { background:'#D0E0F5', borderBottom:'1px solid #BCD2EC', padding:'9px 16px', display:'flex', alignItems:'center' },
  secTitle: { fontSize:'11.5px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', color:'#154D97' },
  secCount: { marginLeft:'auto', fontSize:'11px', fontWeight:600, color:'#154D97', background:'#fff', borderRadius:'10px', padding:'2px 9px' },
  thead:    { background:'#F0F5FB' },
  th:       { padding:'10px 14px', textAlign:'left', fontSize:'10.5px', fontWeight:700, color:'#7189B0', letterSpacing:'0.06em', textTransform:'uppercase', borderBottom:'1px solid #D9E5F4', whiteSpace:'nowrap' },
  td:       { padding:'11px 14px', fontSize:'12.5px', color:'#33415A', borderBottom:'1px solid #EEF1F5', verticalAlign:'middle' },
  tdMuted:  { padding:'11px 14px', fontSize:'12.5px', color:'#8A9AB5', borderBottom:'1px solid #EEF1F5', verticalAlign:'middle' },
  rolePill: { display:'inline-block', fontSize:'10px', fontWeight:600, padding:'2px 8px', borderRadius:'10px', background:'#E4EDF8', color:'#154D97', marginRight:'3px', marginBottom:'2px' },
  loading:  { padding:'40px', textAlign:'center', color:'#8A9AB5', fontSize:'13px' },
  empty:    { padding:'40px', textAlign:'center', color:'#8A9AB5', fontSize:'13px' },
  clickRow: { cursor:'pointer', transition:'background 0.1s', background:'#fff' },
  avatar:   { width:'30px', height:'30px', borderRadius:'50%', background:'#E4EDF8', display:'inline-flex', alignItems:'center', justifyContent:'center', color:'#154D97', fontSize:'11px', fontWeight:700, marginRight:'10px', flexShrink:0 },
  name:     { fontWeight:600, color:'#2E4763' },
  citySub:  { fontSize:'11px', color:'#8A9AB5', marginTop:'1px' },
  email:    { color:'#154D97' },
  addBtn:   { border:'1px dashed #7EA3D7', background:'#fff', color:'#154D97', borderRadius:'20px', padding:'9px 18px', fontSize:'12.5px', fontWeight:600, fontFamily:'inherit', cursor:'pointer', whiteSpace:'nowrap' },
  dropPanel:{ position:'absolute', top:'38px', left:0, width:'430px', border:'1px solid #C9D9EE', borderRadius:'9px', background:'#fff', padding:'5px 0', boxShadow:'0 4px 14px rgba(20,60,120,0.12)', zIndex:20 },
  dropOpt:  { fontSize:'12.5px', color:'#33415A', padding:'8px 12px', cursor:'pointer' },
  dropNote: { fontSize:'11.5px', color:'#8a9ab5', padding:'8px 12px 6px', borderTop:'1px solid #EEF3F9', marginTop:'4px' },
  newCard:  { background:'#fff', border:'1px solid #C9D9EE', borderRadius:'12px', padding:'15px 16px', marginBottom:'16px', boxShadow:'0 1px 3px rgba(20,60,120,0.06)' },
  newTitle: { fontSize:'11.5px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', color:'#154D97', marginBottom:'12px' },
  flow:     { display:'flex', flexWrap:'wrap', gap:'13px 14px', alignItems:'flex-end' },
  lbl:      { fontSize:'11px', color:'#8a9ab5' },
  inp:      { width:'100%', marginTop:'4px', border:'1px solid #C9D9EE', borderRadius:'8px', padding:'8px 10px', fontSize:'13px', background:'#fff', height:'34px', fontFamily:'inherit', color:'#33415A', outline:'none' },
  cancelBtn:{ background:'#fff', border:'1px solid #C5D5EA', color:'#33415A', borderRadius:'8px', padding:'0 16px', height:'34px', fontSize:'13px', fontWeight:600, fontFamily:'inherit', cursor:'pointer' },
  saveBtn:  { background:'#154D97', border:'none', color:'#fff', borderRadius:'8px', padding:'0 20px', height:'34px', fontSize:'13px', fontWeight:600, fontFamily:'inherit', cursor:'pointer' },
  cancelBtn:{ background:'#fff', border:'1px solid #C5D5EA', color:'#33415A', borderRadius:'8px', padding:'0 16px', height:'34px', fontSize:'13px', fontWeight:600, fontFamily:'inherit', cursor:'pointer' },
  errLine:  { fontSize:'12px', color:'#B4532A', background:'#FBF3EE', border:'1px solid #E8D3C4', borderRadius:'8px', padding:'8px 11px', marginTop:'11px' },
};

function initials(name) {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length-1][0]).toUpperCase();
  return parts[0][0].toUpperCase();
}

export default function Contacts({ role }) {
  const [contacts, setContacts] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState('');
  const [roleFilter, setRoleFilter] = useState('All');
  const [selected, setSelected] = useState(null);
  const [adding,   setAdding]   = useState(false);
  const [saving,   setSaving]   = useState(false);
  const [err,      setErr]      = useState('');
  const blank = { first:'', last:'', company:'', phone:'', email:'', role:'' };
  const [draft,    setDraft]    = useState(blank);
  const [newQ,     setNewQ]     = useState('');
  const newMatches = newQ.trim()
    ? contacts.filter(c => (c.fields?.Name || '').toLowerCase().includes(newQ.trim().toLowerCase())).slice(0, 6)
    : [];

  async function createContact() {
    if (saving) return;
    setErr('');
    if (!draft.first.trim() && !draft.last.trim() && !draft.company.trim()) {
      setErr('Enter a first and last name, or a company name.');
      return;
    }
    if (draft.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(draft.email.trim())) {
      setErr('Enter a valid email or leave it blank.');
      return;
    }
    setSaving(true);
    try {
      const fields = {};
      if (draft.first.trim())   fields['First name']       = draft.first.trim();
      if (draft.last.trim())    fields['Last name']        = draft.last.trim();
      if (draft.company.trim()) fields['Company / entity'] = draft.company.trim();
      if (draft.phone.trim())   fields['Phone']            = draft.phone.trim();
      if (draft.email.trim())   fields['Email']            = draft.email.trim();
      if (draft.role)           fields['Role(s)']          = [draft.role];
      const res = await authFetch('/.netlify/functions/create-contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fields }),
      });
      const d = await res.json();
      if (d && d.id) {
        setContacts(prev => [...prev, d]);
        setDraft(blank);
        setAdding(false);
      } else {
        setErr((d && (d.error && (d.error.message || d.error))) || 'Could not create that contact.');
      }
    } catch (e) {
      setErr(e.message || 'Network error creating the contact.');
    }
    setSaving(false);
  }

  useEffect(() => {
    authFetch('/.netlify/functions/get-contacts')
      .then(r => r.json())
      .then(d => { setContacts(d.records || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const filtered = contacts.filter(c => {
    const name    = (c.fields?.Name || '').toLowerCase();
    const email   = (c.fields?.Email || '').toLowerCase();
    const company = (c.fields?.['Company / entity'] || '').toLowerCase();
    const matchSearch = name.includes(search.toLowerCase()) || email.includes(search.toLowerCase()) || company.includes(search.toLowerCase());
    const roles = c.fields?.['Role(s)'] || [];
    const matchRole = roleFilter === 'All' || roles.includes(roleFilter);
    return matchSearch && matchRole;
  });

  return (
    <div>
      <div style={s.toolbar}>
        <input style={s.search} placeholder="Search contacts..." value={search} onChange={e => setSearch(e.target.value)} />
        <select style={s.select} value={roleFilter} onChange={e => setRoleFilter(e.target.value)}>
          {ROLES.map(r => <option key={r}>{r === 'All' ? 'All roles' : r}</option>)}
        </select>
        <button style={s.addBtn} onClick={() => { setAdding(a => !a); setErr(''); }}>+ Contact</button>
      </div>

      {adding && (
        <div style={s.newCard}>
          <div style={s.newTitle}>New contact</div>
          <div style={{ display:'flex', alignItems:'center', gap:'14px', padding:'8px 13px', border:'1px solid #E9EFF6', borderRadius:'10px', marginBottom:'14px', position:'relative' }}>
            <div style={{ position:'relative', width:'430px', flexShrink:0 }}>
              <input autoFocus style={{ ...s.inp, marginTop:0, height:'32px', fontSize:'12.5px', borderColor:'#4A7FBF' }} placeholder="Search contacts or type a name" value={newQ} onChange={e => { setNewQ(e.target.value); const p = e.target.value.trim().split(/\s+/); setDraft(d => ({ ...d, first: p[0] || '', last: p.length > 1 ? p.slice(1).join(' ') : '' })); }} />
              {newQ.trim() && newMatches.length > 0 && (
                <div style={s.dropPanel}>
                  {newMatches.map(c => (
                    <div key={c.id} style={s.dropOpt} onClick={() => { setAdding(false); setNewQ(''); setDraft(blank); setSelected(c.id); }}>
                      <div style={{ fontWeight:600 }}>{c.fields?.Name}</div>
                      <div style={{ fontSize:'11px', color:'#8a9ab5' }}>{[(c.fields?.['Role(s)'] || []).join(', '), c.fields?.['Company / entity']].filter(Boolean).join(' \u00B7 ')}</div>
                    </div>
                  ))}
                  <div style={s.dropNote}>Already a contact. Click to open them instead.</div>
                </div>
              )}
            </div>
            <span style={{ marginLeft:'auto', fontSize:'11px', color:'#8A9AB5', cursor:'pointer' }} onClick={() => { setAdding(false); setNewQ(''); setDraft(blank); setErr(''); }}>Cancel</span>
          </div>
          <div style={s.flow}>
            <div style={{ width:'170px' }}><div style={s.lbl}>First name</div><input style={s.inp} value={draft.first} onChange={e => setDraft(d => ({ ...d, first: e.target.value }))} /></div>
            <div style={{ width:'170px' }}><div style={s.lbl}>Last name</div><input style={s.inp} value={draft.last} onChange={e => setDraft(d => ({ ...d, last: e.target.value }))} /></div>
            <div style={{ width:'210px' }}><div style={s.lbl}>Role</div>
              <select style={{ ...s.inp, cursor:'pointer' }} value={draft.role} onChange={e => setDraft(d => ({ ...d, role: e.target.value }))}>
                <option value="">Select</option>
                {ROLES.filter(r => r !== 'All').map(r => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div style={{ width:'170px' }}><div style={s.lbl}>Phone</div><input style={s.inp} value={draft.phone} onChange={e => setDraft(d => ({ ...d, phone: e.target.value }))} /></div>
            <div style={{ width:'230px' }}><div style={s.lbl}>Email</div><input style={s.inp} value={draft.email} onChange={e => setDraft(d => ({ ...d, email: e.target.value }))} /></div>
            <div style={{ width:'250px' }}><div style={s.lbl}>Company / entity</div><input style={s.inp} value={draft.company} onChange={e => setDraft(d => ({ ...d, company: e.target.value }))} /></div>
            <button style={s.saveBtn} onClick={createContact}>{saving ? 'Saving...' : 'Save'}</button>
            <button style={s.cancelBtn} onClick={() => { setAdding(false); setDraft(blank); setErr(''); }}>Cancel</button>
          </div>
          {err && <div style={s.errLine}>{err}</div>}
          <div style={{ fontSize:'10.5px', color:'#8A94A6', marginTop:'11px' }}>Address, tax ID and W-9 are on the contact record. Save this, then open it to fill the rest.</div>
        </div>
      )}
      <div style={s.tableCard}>
        <div style={s.secBar}>
          <span style={s.secTitle}>Contacts</span>
          <span style={s.secCount}>{filtered.length} contact{filtered.length !== 1 ? 's' : ''}</span>
        </div>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead style={s.thead}>
            <tr>
              <th style={{ ...s.th, width:'26px' }}></th>
              <th style={s.th}>Name</th>
              <th style={s.th}>Role</th>
              <th style={s.th}>Phone</th>
              <th style={s.th}>Email</th>
              <th style={s.th}>State</th>
              <th style={s.th}>Company / entity</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={s.loading}>Loading contacts...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={7} style={s.empty}>No contacts found</td></tr>
            ) : filtered.map((c) => {
              const open = selected === c.id;
              return (
              <React.Fragment key={c.id}>
              <tr
                style={s.clickRow}
                onClick={() => setSelected(open ? null : c.id)}
                onMouseEnter={e => e.currentTarget.style.background = '#F0F5FB'}
                onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                <td style={{ ...s.td, color:'#154D97', fontSize:'10px', paddingRight:0 }}>{open ? '\u25BC' : '\u25B6'}</td>
                <td style={s.td}>
                  <div style={{ display:'flex', alignItems:'center' }}>
                    <div style={s.avatar}>{initials(c.fields?.Name)}</div>
                    <div>
                      <div style={s.name}>{c.fields?.Name || '-'}</div>
                      {c.fields?.City && <div style={s.citySub}>{c.fields.City}</div>}
                    </div>
                  </div>
                </td>
                <td style={s.td}><div style={{ display:'flex', flexWrap:'wrap' }}>{(c.fields?.['Role(s)'] || []).map((r, ri) => <span key={ri} style={s.rolePill}>{r}</span>)}</div></td>
                <td style={s.tdMuted}>{c.fields?.Phone || '-'}</td>
                <td style={{ ...s.tdMuted, ...s.email }}>{c.fields?.Email || '-'}</td>
                <td style={s.tdMuted}>{(Array.isArray(c.fields?.['Home state']) ? c.fields['Home state'].join(', ') : c.fields?.['Home state']) || '-'}</td>
                <td style={s.tdMuted}>{c.fields?.['Company / entity'] || '-'}</td>
              </tr>
              {open && (
                <tr>
                  <td colSpan={7} style={{ padding:0, background:'#fff', borderBottom:'1px solid #EEF1F5' }}>
                    <ContactDetail
                      contact={c}
                      onBack={() => setSelected(null)}
                      onSaved={(id, fields) => setContacts(prev => prev.map(x => x.id === id ? { ...x, fields: { ...x.fields, ...fields } } : x))}
                      onDeleted={(id) => { setSelected(null); setContacts(prev => prev.filter(x => x.id !== id)); }}
                    />
                  </td>
                </tr>
              )}
              </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
